const LOCALE_MAP: Record<string, string> = {
  es: 'es-ES',
  en: 'en-GB',
  fr: 'fr-FR',
  de: 'de-DE',
  pt: 'pt-PT',
};

/**
 * Formats a reservation time range as a compact locale-aware string.
 * e.g. es-ES: "sáb, 6 jun · 09:00 — 09:30"
 * e.g. en-GB: "Sat, 6 Jun · 09:00 — 09:30"
 */
export function formatReservationDatetime(
  startIso: string,
  endIso?: string,
  language = 'es',
): string {
  const locale = LOCALE_MAP[language] ?? 'es-ES';
  try {
    const start = new Date(startIso);
    const datePart = new Intl.DateTimeFormat(locale, {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
    }).format(start);
    const startTime = new Intl.DateTimeFormat(locale, {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).format(start);

    if (endIso) {
      const end = new Date(endIso);
      const endTime = new Intl.DateTimeFormat(locale, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      }).format(end);
      return `${datePart} · ${startTime} — ${endTime}`;
    }
    return `${datePart} · ${startTime}`;
  } catch {
    return startIso;
  }
}
